import React from 'react';
import { Layout } from '../components/layout/Layout';
import { Shield, Lock, AlertTriangle, EyeOff } from 'lucide-react';
export function Safety() {
  return <Layout data-id="element-850">
      <div className="py-20 bg-white" data-id="element-851">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-852">
          <div className="text-center mb-16" data-id="element-853">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-854">
              Safety Center
            </h1>
            <p className="text-xl text-muted-foreground" data-id="element-855">
              Low pressure shouldn't mean low safety.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-856">
            <div className="flex gap-4" data-id="element-857">
              <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0 text-blue-600" data-id="element-858">
                <Shield className="w-6 h-6" data-id="element-859" />
              </div>
              <div data-id="element-860">
                <h3 className="text-xl font-bold mb-2" data-id="element-861">Phone Verified</h3>
                <p className="text-muted-foreground" data-id="element-862">
                  Every account is verified with a real phone number. No bots,
                  no burners.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-863">
              <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0 text-blue-600" data-id="element-864">
                <EyeOff className="w-6 h-6" data-id="element-865" />
              </div>
              <div data-id="element-866">
                <h3 className="text-xl font-bold mb-2" data-id="element-867">Private by Default</h3>
                <p className="text-muted-foreground" data-id="element-868">
                  No public profiles. No search. You can only be contacted if
                  you share your link.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-869">
              <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0 text-blue-600" data-id="element-870">
                <AlertTriangle className="w-6 h-6" data-id="element-871" />
              </div>
              <div data-id="element-872">
                <h3 className="text-xl font-bold mb-2" data-id="element-873">Report with Evidence</h3>
                <p className="text-muted-foreground" data-id="element-874">
                  If someone crosses a line, report them. We take evidence
                  seriously and ban repeat offenders.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-875">
              <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0 text-blue-600" data-id="element-876">
                <Lock className="w-6 h-6" data-id="element-877" />
              </div>
              <div data-id="element-878">
                <h3 className="text-xl font-bold mb-2" data-id="element-879">Data Privacy</h3>
                <p className="text-muted-foreground" data-id="element-880">
                  When you delete a fling, the data is wiped. We don't sell your
                  chat history.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>;
}